import { getMetaDataAll } from '@/services/metadata';
import { useEffect, useState } from 'react';

export default () => {
  const [metadata, setMetadata] = useState<any>();
  const [organizationSelected, setOrganizationSelected] = useState<number | null>();

  useEffect(() => {
    (async () => {
      if (organizationSelected) {
        const res = await getMetaDataAll({ companyId: organizationSelected });
        if (res.success) {
          setMetadata(res.data);
        }
      }
    })();
  }, [organizationSelected]);

  return { metadata, setOrganizationSelected, organizationSelected };
};
